import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import footerLogo from "../../images/wireox-footer.png";
import fedexLogo from "../../images/fedex-logo.png";
import upsLogo from "../../images/ups-logo.png";
import upsLogo1 from "../../images/ups-logo-1.png";
import visaLogo from "../../images/visa-logo.png";
import paypalLogo from "../../images/paypal-logo.png";
import amexLogo from "../../images/amex-logo.png";
import applePayLogo from "../../images/Footer_pay.png";
import discoverLogo from "../../images/Footdiscover.png";

const Footer = () => {
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(false);

  const handleEmailClick = (e) => {
    e.preventDefault();
    setIsEmailModalOpen(true);
  };

  const handleCloseEmailModal = () => {
    setIsEmailModalOpen(false);
  };

  const handlePhoneClick = (e) => {
    e.preventDefault();
    setIsPhoneModalOpen(true);
  };

  const handleClosePhoneModal = () => {
    setIsPhoneModalOpen(false);
  };

  return (
    <>
      <footer className="footer-container">
        {/* Top Section */}
        <div className="footer-top-section">
          <div className="footer-top-content">
            {/* Left Side - Logo and Selectors */}
            <div className="footer-left">
              {/* Logo */}
              <div className="footer-logo">
                <img
                  src={footerLogo}
                  alt="WIRE OX Logo"
                  className="footer-logo-image"
                />
              </div>

              {/* Selectors */}

              <div className="shipping-icons">
                <img src={fedexLogo} alt="FedEx" />
                <img src={upsLogo} alt="USPS" />
                <img src={upsLogo1} alt="UPS" />
              </div>
            </div>

            {/* Navigation Columns */}
            <div className="footer-navigation">
              {/* About Column */}
              <div className="footer-column">
                <h3 className="footer-title">About</h3>
                <ul className="footer-links">
                  <li>
                    <Link to="/about-us">About Us</Link>
                  </li>
                  <li>
                    <Link to="/return-policy">Return Policy</Link>
                  </li>
                  <li>
                    <Link to="/blog">Blog</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/trademark">Trademark Disclaimer</Link>
                  </li>
                  <li>
                    <Link to="/terms-and-conditions">Terms And Conditions</Link>
                  </li>
                </ul>
              </div>

              {/* Services Column */}
              <div className="footer-column">
                <h3 className="footer-title">Services</h3>
                <ul className="footer-links">
                  <li>
                    <Link to="/my-account">My Account</Link>
                  </li>
                  {/* <li>
                    <Link to="/lcd-buy">LCD Buyback</Link>
                  </li> */}
                  <li>
                    <Link to="/preowned-devices">Pre-Owned Devices</Link>
                  </li>
                  {/* Shipping (hidden below Pre-Owned Devices) */}
                  {/* <li>
                    <Link to="/about-us">Shipping</Link>
                  </li> */}
                  {/* <li>
                    <Link to="/quick-order">Marketing Material</Link>
                  </li> */}
                </ul>
              </div>

              {/* Support Column */}
              <div className="footer-column">
                <h3 className="footer-title">Support</h3>
                <ul className="footer-links">
                  <li>
                    <button
                      type="button"
                      onClick={handlePhoneClick}
                      className="footer-phone-link"
                    >
                      <svg
                        className="footer-support-icon"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                      </svg>
                      Phone
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      onClick={handleEmailClick}
                      className="footer-email-link"
                    >
                      <svg
                        className="footer-support-icon"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                      </svg>
                      Email
                    </button>
                  </li>
                  <li>
                    <Link to="/about-us" className="footer-faqs-link">
                      <svg
                        className="footer-support-icon"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                      >
                        <circle cx="12" cy="12" r="10" fill="currentColor" />
                        <text
                          className="footer-faq-icon__mark"
                          x="12"
                          y="12"
                          dominantBaseline="central"
                          textAnchor="middle"
                          fontSize="13"
                          fontWeight="700"
                          fontFamily="Poppins, system-ui, sans-serif"
                        >
                          ?
                        </text>
                      </svg>
                      FAQs
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="footer-divider"></div>

        {/* Bottom Section */}
        <div className="footer-bottom-section">
          <div className="footer-bottom-content">
            {/* Payment Methods */}
            <div className="payment-methods">
              <img src={visaLogo} alt="Visa" className="payment-logo" />
              <span className="payment-methods__spacer" aria-hidden="true" />
              <img src={paypalLogo} alt="PayPal" className="payment-logo" />
              <img
                src={applePayLogo}
                alt="Apple Pay"
                className="payment-logo"
              />
              <img
                src={amexLogo}
                alt="American Express"
                className="payment-logo"
              />
              <img src={discoverLogo} alt="Discover" className="payment-logo" />
            </div>

            {/* Copyright */}
            <div className="copyright-info">
              <p className="copyright-text">
                © 2025 <span className="company-name">WireOx</span>
              </p>
              <p className="Footer-disclaimer-text">
                All trademarks are properties of their respective holders.
                WireOx does not own or make claim to those trademarks used on
                this website in which it is not the holder.
              </p>
            </div>

            {/* Social Media */}
            <div className="footer-right">
              <div className="social-media">
                <a
                  href="https://www.facebook.com"
                  className="social-icon facebook"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Wireox on Facebook"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com"
                  className="social-icon instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Wireox on Instagram"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                  </svg>
                </a>
                <a
                  href="https://www.youtube.com/@mvoltaccessories"
                  className="social-icon youtube"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Wireox on YouTube"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/company/wireox/"
                  className="social-icon linkedin"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Wireox on LinkedIn"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                    <rect x="2" y="9" width="4" height="12" />
                    <circle cx="4" cy="4" r="2" />
                  </svg>
                </a>
                <a
                  href="https://x.com"
                  className="social-icon twitter"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Wireox on X"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Email Contact Modal */}
      {isEmailModalOpen && (
        <div className="email-modal-overlay" onClick={handleCloseEmailModal}>
          <div
            className="email-modal-container"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="email-modal-close-button"
              onClick={handleCloseEmailModal}
            >
              ×
            </button>
            <h2 className="email-modal-heading">Give us an email</h2>
            <div className="email-modal-content">
              <div className="email-modal-email-section">
                <svg
                  className="email-modal-icon"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <span className="email-modal-email-address">
                  info@wireox.com
                </span>
              </div>
              <div className="email-modal-hours-section">
                <div className="email-modal-hours-row">
                  <span className="email-modal-day">Mon-Fri</span>
                  <span className="email-modal-time">
                    09:00 AM-6:00 PM (ET)
                  </span>
                </div>
                <div className="email-modal-hours-row">
                  <span className="email-modal-day">Sat</span>
                  <span className="email-modal-time">Closed</span>
                </div>
                <div className="email-modal-hours-row">
                  <span className="email-modal-day">Sun</span>
                  <span className="email-modal-time">Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Phone Contact Modal */}
      {isPhoneModalOpen && (
        <div className="phone-modal-overlay" onClick={handleClosePhoneModal}>
          <div
            className="phone-modal-container"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="phone-modal-close-button"
              onClick={handleClosePhoneModal}
            >
              ×
            </button>
            <h2 className="phone-modal-heading">Give us a call</h2>
            <div className="phone-modal-content">
              <div className="phone-modal-phone-section">
                <svg
                  className="phone-modal-icon"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                <span className="phone-modal-phone-number">248 259 4685</span>
              </div>
              <div className="phone-modal-hours-section">
                <div className="phone-modal-hours-row">
                  <span className="phone-modal-day">Mon-Fri</span>
                  <span className="phone-modal-time">
                    09:00 AM-6:00 PM (ET)
                  </span>
                </div>
                <div className="phone-modal-hours-row">
                  <span className="phone-modal-day">Sat</span>
                  <span className="phone-modal-time">Closed</span>
                </div>
                <div className="phone-modal-hours-row">
                  <span className="phone-modal-day">Sun</span>
                  <span className="phone-modal-time">Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
